function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prototype"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M22.218,29a3.252,3.252,0,0,1-3.248-3.247V16.615a3.252,3.252,0,0,1,3.248-3.248h3.534A3.252,3.252,0,0,1,29,16.615v9.138A3.251,3.251,0,0,1,25.753,29ZM3.882,23.125V18.956a1.133,1.133,0,1,1,2.266,0v4.169a3.609,3.609,0,1,0,7.219,0V5.875a5.876,5.876,0,0,1,11.751,0v4.169a1.133,1.133,0,1,1-2.265,0V5.875a3.61,3.61,0,1,0-7.22,0V23.125a5.876,5.876,0,0,1-11.751,0Zm-.635-7.492A3.252,3.252,0,0,1,0,12.385V3.247A3.251,3.251,0,0,1,3.247,0H6.782A3.251,3.251,0,0,1,10.03,3.247v9.138a3.252,3.252,0,0,1-3.247,3.248Z",
  transform: "translate(0)",
  fill: "#fff"
})));

function SvgDesktopI2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopI2);
export default __webpack_public_path__ + "static/media/desktopI2.016e117b.svg";
export { ForwardRef as ReactComponent };